import React, { FunctionComponent } from 'react';
import ParentComponent, {
  TParentComponentProps,
} from '@views/components/common/ParentComponent';

export const CartProductInfo: FunctionComponent<TParentComponentProps> = (
  props
) => {
  return <ParentComponent {...props} />;
};

CartProductInfo.defaultProps = {
  defaultClassName: 'cart-product__info',
  as: 'div',
};

export default CartProductInfo;
